namespace TabAurous.Production {
    export interface DismantlingReturnRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Remark?: string;
        CompanyId?: number;
        EmployeeId?: number;
        FinancialYearId?: number;
        UserId?: number;
        Username?: string;
        ItemDetails?: DismantlingReturnItemsRow[];
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        AutoPosting?: boolean;
    }

    export namespace DismantlingReturnRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.DismantlingReturn';
        export const deletePermission = 'Production:DismantlingReturn:Delete';
        export const insertPermission = 'Production:DismantlingReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:DismantlingReturn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            Username = "Username",
            ItemDetails = "ItemDetails",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            AutoPosting = "AutoPosting"
        }
    }
}
